import { fromTheme } from '@kyruus/ui-theme';
import styled from '@emotion/styled';

export const AlertMarkdownContainer = styled('div')`
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
  & a {
    color: ${fromTheme('color_link')};
  }
`;
